<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
      <span slot="tab">
        <a-icon type="safety-certificate" />
        Seguridad social
      </span>
        <plano-ss-2388 :endpoint="'plano_ss_2388'"/>
      </a-tab-pane>
      <a-tab-pane key="2">
      <span slot="tab">
        <a-icon type="clock-circle" />
        Historico seguridad social
      </span>
        <plano-ss-2388 :endpoint="'plano_ss_hist_2388'"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {

}
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/TabPlanoSs2388.vue